export const networkType = {
  setNetworkData: "SETNETWORKDATA"
};
export const peerType = {
  peerData: "PEERDATA"
};
